import React from 'react';
import SidebarUnitDesktop
    from "components/sidebar/components/SidebarUnitDesktop";
import {ProfilIcon} from "assets/icons";

const ProfilLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Profil"} 
            routeSidebar={"/profil/myAccountCompany"}
            icon={ProfilIcon}
            text={"Profil"}
        />
    );
};

export default ProfilLink;